import React from 'react';



export default class BaseHomePageLogoWrapper extends React.Component {

    static defaultProps = {
        logos: []
    }

    renderLogos() {
        return this.props.logos.map(d => {
            return (
                <div className={'partner-logo-wrapper'}>
                    {/*<div className={'partner-logo'}>*/}
                        <img src={"https://statichouse.pacefi.com/logo/partners/" + d}/>
                    {/*</div>*/}
                </div>
            )
        })
    }

    render() {
         return (
             <>
                 {this.props.logos.length ?
                     <div className={'base-logo-wrapper'}>
                         <div className={'flx partner-logos-box'}>
                             {this.renderLogos()}
                         </div>
                     </div> : <div></div>
                 }
             </>
         )
    }
}
